const ENV = {
    REACT_APP_SERVER_URL: process.env.REACT_APP_SERVER_URL,
    REACT_APP_SKYGATE_AUTH_KEY: process.env.REACT_APP_SKYGATE_AUTH_KEY,
}

export default ENV
